import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getArticleDetail, getAllArticles } from '../utils/articleManager';
import { Link } from 'react-router-dom';

export default function ReadingComprehension() {
  const { articleId } = useParams();
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);
  
  const articles = getAllArticles();
  const article = articles.find(a => a.id === parseInt(articleId));
  const articleDetail = getArticleDetail(parseInt(articleId));
  
  const questions = articleDetail?.questions || [];
  
  const handleAnswer = (questionIndex, choice) => {
    setAnswers({ ...answers, [questionIndex]: choice });
  };
  
  const calculateScore = () => {
    let correct = 0;
    questions.forEach((q, index) => {
      if (answers[index] === q.correctAnswer) {
        correct++;
      }
    });
    return correct;
  };
  
  const handleSubmit = () => {
    const correctCount = calculateScore();
    setScore(correctCount);
    setShowResults(true);
  };
  
  const handleRetry = () => {
    setAnswers({});
    setShowResults(false);
    setScore(0);
  };
  
  if (!article) {
    return (
      <div className="container">
        <h1>文章不存在</h1>
        <Link to="/" className="btn btn-primary">返回首页</Link>
      </div>
    );
  }
  
  return (
    <div className="container">
      {/* 头部 */}
      <div className="section-header">
        <Link to="/" className="btn btn-outline" style={{ marginBottom: '16px' }}>← 返回首页</Link>
        <h1>📖 {article.title}</h1>
        {article.source && <p className="article-source">来源：{article.source}</p>}
      </div>
      
      {/* 文章内容 */}
      <div className="reading-section">
        <h2>📝 文章原文</h2>
        <div className="article-content">
          {articleDetail?.paragraphs?.map((paragraph, index) => (
            <p key={index} className="article-paragraph">
              {paragraph.original}
            </p>
          ))}
        </div>
      </div>
      
      {/* 阅读理解题目 */}
      <div className="questions-section">
        <h2>🧩 阅读理解</h2>
        <p className="section-desc">共 {questions.length} 题，每题 {questions.length > 0 ? Math.round(100/questions.length) : 0} 分</p>
        
        {questions.length > 0 ? (
          <div className="questions-list">
            {questions.map((question, index) => (
              <div key={index} className="question-item">
                <div className="question-number">第 {index + 1} 题</div>
                <div className="question-text">{question.question}</div>
                <div className="question-options">
                  {question.options.map((option, optIndex) => {
                    const isSelected = answers[index] === option.key;
                    const isCorrect = question.correctAnswer === option.key;
                    const showCorrect = showResults;
                    
                    let optionClass = 'option-item';
                    if (showCorrect) {
                      if (isCorrect) {
                        optionClass += ' option-correct';
                      } else if (isSelected && !isCorrect) {
                        optionClass += ' option-wrong';
                      }
                    } else if (isSelected) {
                      optionClass += ' option-selected';
                    }
                    
                    return (
                      <div
                        key={optIndex}
                        className={optionClass}
                        onClick={() => !showResults && handleAnswer(index, option.key)}
                      >
                        <span className="option-key">{option.key}</span>
                        <span className="option-text">{option.text}</span>
                        {showCorrect && isCorrect && <span className="option-mark">✓</span>}
                        {showCorrect && isSelected && !isCorrect && <span className="option-mark">✗</span>}
                      </div>
                    );
                  })}
                </div>
                {showResults && (
                  <div className="question-analysis">
                    <h4>解析：</h4>
                    <p>{question.analysis}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="empty-state">该文章暂无阅读理解题目</p>
        )}
      </div>
      
      {/* 提交按钮 */}
      <div className="action-bar">
        {!showResults ? (
          <button 
            className="btn btn-primary" 
            onClick={handleSubmit}
            disabled={Object.keys(answers).length < questions.length}
          >
            📤 提交答案
          </button>
        ) : (
          <div className="results-section">
            <div className="score-display">
              <span className="score-label">得分：</span>
              <span className="score-value">{score}</span>
              <span className="score-total">/{questions.length}</span>
            </div>
            <button className="btn btn-accent" onClick={handleRetry}>
              🔄 重新答题
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
